<template>
	<div style="width: 95%;margin: 0 auto;">
		<div
			style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
			招标通告
		</div>

		<div @click="cid='6'"
			style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;">
			点击添加招标通告
		</div>


		<!-- <div style="width: 90%;margin-left: 3%;height: 40px;margin-top: 25px;box-shadow: #6e6e6e 0px 0px 10px;">
			<div
				style="width: 550px;height: 30px;font-weight: 800;text-align: center;line-height: 30px;font-size: 18px;margin-left: 20px;">
				<el-radio-group v-model="cid" @change="qbesb">
					<el-radio-button label="4">期刊</el-radio-button>
					<el-radio-button label="6">期刊添加</el-radio-button>
				</el-radio-group>
			</div>
		</div> -->

		<div style="width: 100%;min-height: 300px;margin-top: 25px;">
			<div v-show="cid=='4'" style="width: 100%;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;" v-for="(item,index) in gjqka">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;">
							{{item.title}}
						</div>
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}}
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;text-align: center;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>
						<router-link tag="div"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;"
							:to="{path: '/zbggdetail', query: {id:item.id,title:item.title}}">
							查看
						</router-link>
						<div @click="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
							删除
						</div>
					</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
						:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
					</el-pagination>
				</div>
			</div>

			<!-- 国际期刊 -->
			<div v-show="cid=='6'" style="width: 90%;margin-left: 3%;min-height: 300px;margin-top: 25px;">
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						信息标题:
					</div>
					<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						发布单位:
					</div>
					<el-input v-model="form.issued_by" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				
				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						地区:
					</div>
					<el-select style="float: left;margin-top: 5px;" v-model="form.city" filterable placeholder="请选择">
						<el-option v-for="item in optionsss" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>

				<!-- <div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						地区:
					</div>
					<el-cascader placeholder="地区选择" class="eloptionxg" :options="industry" @change="handleAreaChange"
						filterable>
					</el-cascader>
				</div> -->

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						单位类型:
					</div>
					<el-select v-model="form.unit_type" placeholder="请选择" style="float: left;margin-top: 5px;">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<!-- <el-input v-model="form.unit_type" style="float: left;width: 70%;margin-top: 5px;"></el-input> -->
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						发布人:
					</div>
					<el-input v-model="form.publisher" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						联系电话:
					</div>
					<el-input v-model="form.phone" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						邮件地址:
					</div>
					<el-input v-model="form.email" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						项目类型:
					</div>
					<el-select v-model="form.xm_type" placeholder="请选择" style="float: left;margin-top: 5px;">
						<el-option v-for="item in optionss" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<!-- <el-input v-model="form.xm_type" style="float: left;width: 70%;margin-top: 5px;"></el-input> -->
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						付费下载金额:
					</div>
					<el-input v-model="form.money" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>


				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						文件:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pdf" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessssq" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListssqs">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>

				<div style="width: 100%;height: 550px;margin-top: 25px;margin-bottom: 25px;">
					<div style="width: 40%;height: 50px;float: left;line-height: 50px;text-align: center;">
						简介 <span style="font-size: 12px;">上传图片大小控制再“600 x 350”之间)</span> :
					</div>
					<div style="float: left;width: 90%;margin-left: 5%;height: 500px;">
						<vue-tinymce v-model="form.content" :setting="setting" />
					</div>
				</div>

				<div style="height: 50px;width: 200px;margin: 0 auto;">
					<el-button type="primary" @click="onSubmit">立即创建</el-button>
					<el-button @click="cid='4'">取消</el-button>
				</div>
			</div>


			<!-- 国内期刊 -->
			<div v-show="cid=='7'" style="width: 90%;margin-left: 3%;min-height: 300px;margin-top: 25px;">
				国内期刊
			</div>

		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				list: [],
				currentPage: 1, //当前页
				PageSize: 20, //当前每页数据
				Totals: 100, //总数据条数
				cid: '4',
				gjqka: '',
				isShow: false,
				options: [{
					value: '业主',
					label: '业主'
				}, {
					value: '招标代理机构',
					label: '招标代理机构'
				}, {
					value: '其他',
					label: '其他'
				}],
				optionsss: [{
						value: '北京市',
						label: '北京市'
					},
					{
						value: '上海市',
						label: '上海市'
					}, {
						value: '天津市',
						label: '天津市'
					}, {
						value: '重庆市',
						label: '重庆市'
					}, {
						value: '河北省',
						label: '河北省'
					}, {
						value: '山西省',
						label: '山西省'
					}, {
						value: '辽宁省',
						label: '辽宁省'
					}, {
						value: '吉林省',
						label: '吉林省'
					}, {
						value: '河南省',
						label: '河南省'
					}, {
						value: '江苏省',
						label: '江苏省'
					}, {
						value: '浙江省',
						label: '浙江省'
					}, {
						value: '安徽省',
						label: '安徽省'
					}, {
						value: '福建省',
						label: '福建省'
					}, {
						value: '江西省',
						label: '江西省'
					}, {
						value: '山东省',
						label: '山东省'
					}, {
						value: '湖北省',
						label: '湖北省'
					}, {
						value: '湖南省',
						label: '湖南省'
					}, {
						value: '广东省',
						label: '广东省'
					}, {
						value: '海南省',
						label: '海南省'
					}, {
						value: '四川省',
						label: '四川省'
					}, {
						value: '贵州省',
						label: '贵州省'
					}, {
						value: '云南省',
						label: '云南省'
					}, {
						value: '陕西省',
						label: '陕西省'
					}, {
						value: '甘肃省',
						label: '甘肃省'
					}, {
						value: '青海省',
						label: '青海省'
					}, {
						value: '黑龙江省',
						label: '黑龙江省'
					}, {
						value: '内蒙古自治区',
						label: '内蒙古自治区'
					}, {
						value: '广西壮族自治区',
						label: '广西壮族自治区'
					}, {
						value: '西藏自治区',
						label: '西藏自治区'
					}, {
						value: '宁夏回族自治区',
						label: '宁夏回族自治区'
					}, {
						value: '新疆维吾尔自治区',
						label: '新疆维吾尔自治区'
					}, {
						value: '台湾省',
						label: '台湾省'
					}, {
						value: '香港特别行政区',
						label: '香港特别行政区'
					}, {
						value: '澳门特别行政区',
						label: '澳门特别行政区'
					}, {
						value: '其它',
						label: '其它'
					}
				],
				optionss: [{
					value: '招标公告',
					label: '招标公告'
				}, {
					value: '中标结果',
					label: '中标结果'
				}, {
					value: '招标预告',
					label: '招标预告'
				}, {
					value: '招标变更',
					label: '招标变更'
				}],
				setting: {
					menubar: false,
					toolbar: 'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
					styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
					table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs ltr rtl | emoticons help | wordcount',
					toolbar_drawer: "sliding",
					quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
					plugins: "link image media table lists fullscreen quickbars advlist autosave directionality emoticons help imagetools pagebreak preview print wordcount",
					language: 'zh_CN', //本地化设置
					height: 500,
					selector: '#textarea1',
					automatic_uploads: false,
					images_upload_url: 'https://admin.shipoe360.com/ueditorphp/controller.php',
					fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
					font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',

				},
				form: {
					issued_by: '',
					content: '',
					unit_type: '',
					publisher: '',
					phone: '',
					email: '',
					title: '',
					money: '',
					xm_type: '',
					file: '',
					city: ''
				},
				fileListssqs: [],
				industry: [],
				qbe: false,
				qid: '',
			}
		},
		methods: {
			async getlist() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/personl_zbtg_index', {
					// uid: 1,
					uid: loginInfo.id
				})
				console.log(res)
				this.gjqka = res.data.data.list
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
			async onSubmit() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (this.qbe == true) {
					let res1 = await http.post('api/picture/ppt_edit', {
						uid: loginInfo.id,
						// uid:1,
						issued_by: this.form.issued_by,
						unit_type: this.form.unit_type,
						content: this.form.content,
						publisher: this.form.publisher,
						phone: this.form.phone,
						email: this.form.email,
						title: this.form.title,
						money: this.form.money,
						xm_type: this.form.xm_type,
						file: this.form.file,
						city: this.form.city,
						id: this.qid,
					})
					console.log(res1)
					if (res1.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '修改成功',
							type: 'success'
						});
						this.cid = '4'
						this.form.issued_by = ''
						this.form.content = ''
						this.form.unit_type = ''
						this.form.publisher = ''
						this.form.phone = ''
						this.form.email = ''
						this.form.title = ''
						this.form.money = ''
						this.form.xm_type = ''
						this.form.file = ''
						this.form.city = ''
						this.fileListssqs = []
						this.getlist()
					}
				} else if (this.qbe == false) {
					let res = await http.post('api/picture/zbtg_add', {
						uid: loginInfo.id,
						// uid:1,
						issued_by: this.form.issued_by,
						unit_type: this.form.unit_type,
						content: this.form.content,
						publisher: this.form.publisher,
						phone: this.form.phone,
						email: this.form.email,
						title: this.form.title,
						money: this.form.money,
						xm_type: this.form.xm_type,
						file: this.form.file,
						city: this.form.city,
					})
					console.log(res)
					if (res.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '添加成功',
							type: 'success'
						});
						this.cid = '4'
						this.form.issued_by = ''
						this.form.content = ''
						this.form.unit_type = ''
						this.form.publisher = ''
						this.form.phone = ''
						this.form.email = ''
						this.form.title = ''
						this.form.money = ''
						this.form.xm_type = ''
						this.form.file = ''
						this.form.city = ''
						this.fileListssqs = []
						this.getlist()
					}
				}
			},
			handleAreaChange(val) {
				this.city = val[1]
				console.log(this.city)
			},
			async getlists() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/domestic_journals', {
					// uid: 1,
					uid: loginInfo.id
				})
				this.gjqka = res.data.data.list
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
			qbesb() {
				console.log(this.cid)
				if (this.cid == '4') {
					this.getlist();
					this.isShow = false
					this.form.title = ''
					this.form.picture = ''
					this.form.content = ''
					this.form.contry_type = ''
					this.form.eg_title = ''
					this.form.qk_pdf = ''
					this.form.qk_year = ''
					this.form.qk_number = ''
					this.form.qk_count = ''
					this.fileListssq = []
					this.fileListssqs = []
				} else if (this.cid == '5') {
					this.getlists();
					this.isShow = false
				} else if (this.cid == '6') {
					this.isShow = true
				} else if (this.cid == '7') {
					this.isShow = true
				}
			},
			xiugaia(val) {
				console.log(val)
				this.qid = val.id,
					this.form.issued_by = val.issued_by
				this.form.content = val.content
				this.form.unit_type = val.unit_type
				this.form.publisher = val.publisher
				this.form.phone = val.phone
				this.form.email = val.email
				this.form.title = val.title
				this.form.money = val.money
				this.form.xm_type = val.xm_type
				this.form.file = val.file
				this.form.city = val.city
				this.cid = '6'
				this.qbe = true


				let fileArrss = [];
				let fileObjss = {};
				fileObjss.name = "文件";
				fileObjss.url = val.file;
				fileArrss.push(fileObjss);
				this.fileListssqs = fileArrss
			},
			async detela(id, mid) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/zbtg_delete', {
					id: id,
				})
				console.log(res)
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '删除成功',
						type: 'success'
					});
					this.getlist();
				}
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			handlePreview(file) {
				console.log(file);
			},
			handsuccessssq(response, file, fileList) {
				this.form.file = response.data.path
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			async handleCurrentChange(val) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/personl_page_zbtg', {
					uid: loginInfo.id,
					// uid: 1,
					page: val
				})

				this.gjqka = res.data.data.list
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
		},
		async mounted() {
			this.getlist();
			let res = await http.get('api/qydb/index')
			let batchdata = res.data.data
			let dataValueBatch = batchdata => batchdata.map(({
				id,
				name,
				child_1
			}) => (child_1 ? {
				value: id,
				label: name,
				children: dataValueBatch(child_1)
			} : {
				value: id,
				label: name
			}))
			this.industry = dataValueBatch(batchdata)
		}
	}
</script>

<style>
</style>
